import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal } from "bootstrap";
// css
import "./UserListing.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import searchbtn from "../../../Assets/images/search.svg";
import Pagination from "../../Pagination/Pagination";
import deleteimg from "../../../Assets/images/delete-img.png";
// custom import
import userManagementService from "../../../Services/UserManagement/UserManagementService";
import showToast from "../../../Utils/Toast/ToastNotification";
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import {
  showLoader,
  hideLoader,
} from "../../../Redux/Slice/Loader/loaderSlice";

const UserListing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  // states
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [roles, setRoles] = useState([]);
  const [userData, setUserData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState({
    role: "",
    status: "",
    invitation_status: "",
    start_date: "",
    end_date: "",
    page: 1,
    limit: 10,
  });

  const token = useSelector((state) => state.auth?.user?.data?.body?.data?.token)

  const getRoles = async () => {
    dispatch(showLoader());
    try {
      const getRoles = await userManagementService.getRole(token);

      if (getRoles.data?.statusCode === 200) {
        setRoles(getRoles.data.body.data.roles);
      }
    } catch (error) {
      showToast("error", "Something went wrong");
    } finally {
      dispatch(hideLoader());
    }
  };

  const getUserManagement = async () => {
    dispatch(showLoader())
    const params = {
      search: searchQuery || "",
      role_id: filters.role || "",
      is_active: filters.status || "",
      invitation_status: filters.invitation_status || "",
      start_date: filters.start_date || "",
      end_date: filters.end_date || "",
      page: page + 1,
      limit: rowsPerPage,
      sort_by: sortBy,
      sort_order: sortOrder,
    };

    try {
      const getUsers = await userManagementService.getUserManagement(params, token);

      if (getUsers?.data?.statusCode === 200) {
        setUserData(getUsers.data.body);
        setUsers(getUsers.data.body.data.users);
        setTotalRecords(getUsers.data.body?.data?.total || 0);
      } else {
        showToast("error", "Failed to load Users data");
      }
    } catch (error) {
      await HandleApiError(error);
    } finally {
      dispatch(hideLoader());  // Hide loader
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setPage(0);
  };

  useEffect(() => {
    getUserManagement();
    getRoles();
  }, [debouncedSearch, page, rowsPerPage, sortBy, sortOrder]);

  const handleFilterChange = (e) => {
    const { id, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [id]: value,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    getUserManagement();
  };
  const modalRef = useRef(null);

  const openModal = () => {
    if (modalRef.current) {
      const modalInstance = new Modal(modalRef.current, { backdrop: "static" });

      // Ensure no old instance is running
      const oldInstance = Modal.getInstance(modalRef.current);
      if (oldInstance) {
        oldInstance.dispose(); // Destroy previous instance
      }
      const newInstance = new Modal(modalRef.current, { backdrop: "static" });
      newInstance.show();
    }
  };
  const handleFocus = (ref) => {
    if (ref.current) {
      ref.current.showPicker?.(); // Open date picker if supported
    }
  };

  const handleClearFilter = (e) => {
    e.preventDefault();
    // Reset filter state
    setFilters({
      role: "",
      status: "",
      invitation_status: "",
      start_date: "",
      end_date: "",
      page: page + 1,
      limit: rowsPerPage,
    });
    setIsFilterCleared(true);
    setSearchQuery("");
    if (startDateRef.current) startDateRef.current.value = "";
    if (endDateRef.current) endDateRef.current.value = "";
    // getUserManagement();
  };

  useEffect(() => {
    if (isFilterCleared) {
      getUserManagement();
      setIsFilterCleared(false); // Reset flag
    }
  }, [isFilterCleared]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500); // API will be called only after 500ms of no typing

    return () => clearTimeout(delayDebounce); // Clear timeout on new keystroke
  }, [searchQuery]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      setSortBy(column);
      setSortOrder("ASC");
    }
  };

  const handleResend = async (user) => {
    try {
      dispatch(showLoader());

      // Send the user email to your resend API
      const response = await userManagementService.resendEmail({ email: user.email }, token);

      if (response?.data?.statusCode === 200) {
        showToast("success", "Invitation resent successfully!");
        getUserManagement();
      } else {
        showToast("error", "Failed to resend invitation.");
      }
    } catch (error) {
      HandleApiError(error);
    } finally {
      dispatch(hideLoader());
    }
  };



  return (
    <>
      <div className="main-inner-block">
        <div className="content">
          <div className="d-flex align-items-center justify-content-between mb-4 block-one user-listing-mob gap-3">
            <div className="heading-content ms-0 mt-0">Listing User</div>
            <div className="heading-content mt-0">
              <button
                type="submit"
                class="green-btn green-signin addnewuser"
                onClick={() => navigate("/create-user")}
              >
                + Add New User
              </button>
            </div>
          </div>
          <div className="white-box bg-box-mob">
            <div className="inner-content-block">
              <div className="listing-title-block d-flex justify-content-between">
                <div className="box-listing-title">
                  Listing User Details
                  <span className="d-block">
                    Showing a list of users detail.
                  </span>
                </div>
                <div className="searchbar-btn d-flex align-items-center gap-4">
                  <div className="input-search-box position-relative">
                    <input
                      type="text"
                      id="name"
                      placeholder="Search"
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                    <div className="searchbtn">
                      <img src={searchbtn} alt="searchbtn"></img>
                    </div>
                    {searchQuery && (
                      <button
                        className="clear-btn"
                        onClick={() => setSearchQuery("")}
                      >
                        ✖
                      </button>
                    )}
                  </div>
                  <div className="filter d-flex gap-4 align-items-center">
                    <a
                      className="filter-inner"
                      href="#"
                      // onClick={(e) => {
                      //   e.preventDefault();
                      //   openModal();
                      // }}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      <span className="me-2">
                        <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5 10.332H15M2.5 5.33203H17.5M7.5 15.332H12.5"
                            stroke="#475467"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      Filter
                    </a>
                    <div
                      class="modal fade"
                      id="exampleModal"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div className="text-end">
                            <button
                              type="button"
                              class="btn-close "
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>

                          <div>
                            <h1
                              class="modal-title fs-5 text-center filter-title"
                              id="exampleModalLabel"
                            >
                              User Management Filter
                            </h1>
                          </div>
                          <div class="modal-body">
                            <form
                              onSubmit={(e) => {
                                e.preventDefault(); // Prevent page reload
                                getUserManagement(); // Apply filters
                              }}
                            >
                              <div className="mb-3">
                                <label htmlFor="role" className="form-label">
                                  Role
                                </label>
                                <select
                                  className="form-select"
                                  id="role"
                                  value={filters.role}
                                  onChange={handleFilterChange}
                                >
                                  <option value="" disabled>Select Role</option>

                                  {roles.map((role) => (
                                    <option key={role.id} value={role.id}>
                                      {role.name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div class="mb-3">
                                <label for="status" class="form-label">
                                  Status
                                </label>
                                <select
                                  className="form-select"
                                  id="status"
                                  value={filters.status}
                                  onChange={handleFilterChange}
                                >
                                  <option value="" disabled> Select Status</option>
                                  <option value="true">Active</option>
                                  <option value="false">Inactive</option>
                                </select>
                              </div>
                              <div class="mb-3">
                                <label
                                  for="invitation_status"
                                  class="form-label"
                                >
                                  Invitation Status
                                </label>
                                <select
                                  className="form-select"
                                  id="invitation_status"
                                  name='invitation_status'
                                  value={filters.invitation_status}
                                  onChange={handleFilterChange}
                                >
                                  <option value="" disabled>
                                    Select Invitation Status
                                  </option>
                                  <option value="pending">Pending</option>
                                  <option value="accepted">Accepted</option>
                                  <option value="expired">Expired</option>
                                </select>
                              </div>
                              <div class="mb-3">
                                <label
                                  htmlFor="start_date"
                                  className="form-label"
                                >
                                  Start Date
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="start_date"
                                  name="start_date"
                                  ref={startDateRef}
                                  onClick={() => handleFocus(startDateRef)}
                                  onChange={handleFilterChange}
                                />
                              </div>
                              <div class="">
                                <label htmlFor="end_date" className="form-label">
                                  End Date
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="end_date"
                                  name="end_date"
                                  ref={endDateRef}
                                  onChange={handleFilterChange}
                                  onClick={() => handleFocus(endDateRef)} // Opens the calendar on focus
                                />
                              </div>
                              <div className="text-center">
                                <button
                                  type="submit"
                                  class="green-btn updt-button"
                                  data-bs-dismiss="modal"
                                  onClick={(e) => handleFilterSubmit(e)}
                                >
                                  Filter
                                </button>
                                <button
                                  type="button"
                                  class="green-btn updt-button ms-2"
                                  data-bs-dismiss="modal"
                                  onClick={handleClearFilter}
                                >
                                  Clear Filter
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-block d-none d-md-block">
                <table class="table">
                  <thead class="table-headers">
                    <tr>
                      <th onClick={() => handleSort("first_name")}>
                        Name
                        <span className="ms-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="10"
                            height="17"
                            viewBox="0 0 32 32"
                          >
                            <g>
                              <path
                                d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                                fill="#949494"
                                opacity="1"
                              />
                            </g>
                          </svg>
                        </span>
                      </th>

                      <th onClick={() => handleSort("email")}>
                        Email
                        <span className="ms-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="10"
                            height="17"
                            viewBox="0 0 32 32"
                          >
                            <g>
                              <path
                                d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                                fill="#949494"
                                opacity="1"
                              />
                            </g>
                          </svg>
                        </span>
                      </th>
                      <th>Phone Number</th>
                      <th>
                        Role
                      </th>
                      <th>
                        Status
                      </th>
                      <th>
                        {" "}
                        Invitation Status
                      </th>
                      <th onClick={() => handleSort("created_at")}>
                        Date Created
                        <span className="ms-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="10"
                            height="17"
                            viewBox="0 0 32 32"
                          >
                            <g>
                              <path
                                d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                                fill="#949494"
                                opacity="1"
                              />
                            </g>
                          </svg>
                        </span>
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.length > 0 ? (
                      users.map((user, index) => (
                        <tr key={user.id}>
                          <td>
                            <a className="name-email-text"
                              onClick={() => navigate(`/view-user/${user.user_id}`)}
                            >
                              <span>{user.first_name || "-"}</span>{" "}
                              <span>{user.last_name || "-"}</span>
                            </a>
                          </td>

                          <td>
                            <a className="name-email-text"
                              style={{ textDecoration: 'none', color: 'inherit' }}
                              onClick={() => navigate(`/view-user/${user.user_id}`)}
                            >
                              {user.email}
                            </a>
                          </td>
                          <td style={{ textAlign: !user.phone_number ? 'center' : 'left' }}>
                            {user.phone_number ? user.country_code + " " + user.phone_number : "-"}
                          </td>

                          <td>{user.role.name}</td>
                          <td>
                            <a
                              className={
                                user.is_active
                                  ? "active-class"
                                  : "inactive-class"
                              }
                            >
                              {user.is_active ? "Active" : "Inactive"}
                            </a>
                          </td>
                          <td>
                            <a
                              className={
                                user.invitation_status === "pending"
                                  ? "pending-sts"
                                  : user.invitation_status === "accepted"
                                    ? "accepted-sts"
                                    : "expired-sts"
                              }
                            >
                              {user.invitation_status.charAt(0).toUpperCase() +
                                user.invitation_status.slice(1)}
                            </a>
                            {/* //for resendlink */}
                            {user.invitation_status === "expired" && (
                              <button
                                className="resend-btn"
                                onClick={() => handleResend(user)}
                                title="Resend Invitation"
                              >
                                <i class="fa fa-repeat" aria-hidden="true"></i>
                              </button>
                            )}
                          </td>
                          <td>
                            {user.created_at
                              ? new Date(user.created_at).toLocaleDateString()
                              : "-"}
                          </td>
                          <td>
                            <div className="d-flex gap-3">
                              <a
                                className="tooltip-container d-flex align-items-center text-decoration-none fonticon cursor-pointer"
                                onClick={() => navigate(`/view-user/${user.user_id}`)}
                              >
                                <i className="fas fa-eye me-2"></i>
                                <span className="tooltip-text">View</span>
                              </a>

                              <a
                                className="tooltip-container d-flex align-items-center text-decoration-none fonticon cursor-pointer"
                                onClick={() => navigate(`/update-user/${user.user_id}`)}
                              >
                                <i className="fas fa-pencil-alt me-2"></i>
                                <span className="tooltip-text">Update</span>
                              </a>
                            </div>

                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No users found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* responsive */}
              <div className="mobile-user-list d-block d-md-none">
                {users?.length > 0 ? (
                  users.map((user) => (
                    <div key={user.id} className="user-card">
                      <div className="user-info">
                        <strong>Name:</strong> {user.first_name || "-"} {user.last_name || "-"}
                      </div>
                      <div className="user-info">
                        <strong>Email:</strong> {user.email}
                      </div>
                      <div className="user-info">
                        <strong>Phone:</strong> {(user?.country_code || "") + " " + (user?.phone_number || "")}
                      </div>
                      <div className="user-info">
                        <strong>Role:</strong> {user.role.name}
                      </div>
                      <div className="user-info">
                        <strong>Status:</strong>
                        <span className={user.is_active ? "active-class" : "inactive-class"}>
                          {user.is_active ? "Active" : "Inactive"}
                        </span>
                      </div>
                      <div className="user-info">
                        <strong>Invitation Status:</strong>
                        <span className={
                          user.invitation_status === "pending" ? "pending-sts" :
                            user.invitation_status === "accepted" ? "accepted-sts" :
                              "expired-sts"
                        }>
                          {user.invitation_status.charAt(0).toUpperCase() + user.invitation_status.slice(1)}
                          {user.invitation_status === "expired" && (
                            <button
                              className="resend-btn"
                              onClick={() => handleResend(user)}
                              title="Resend Invitation"
                            >
                              <i class="fa fa-repeat" aria-hidden="true"></i>
                            </button>
                          )}
                        </span>
                      </div>
                      <div className="user-info">
                        <strong>Date Created:</strong> {user.created_at ? new Date(user.created_at).toLocaleDateString() : "-"}
                      </div>
                      <div className="d-flex justify-content-end mt-3 gap-3">
                        <a
                          className="d-flex align-items-center text-decoration-none fonticon"
                          onClick={() =>
                            navigate(`/view-user/${user.user_id}`)
                          }
                        >
                          <i className="fas fa-eye me-2"></i>
                        </a>
                        <a
                          className="d-flex align-items-center text-decoration-none fonticon"
                          onClick={() =>
                            navigate(`/update-user/${user.user_id}`)
                          }
                        >
                          <i className="fas fa-pencil-alt me-2"></i>
                        </a>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center">No users found</p>
                )}
              </div>
              <div className="pagination-block">
                {
                  <Pagination
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onRowsPerPageChange={handleRowsPerPageChange}
                  />
                }
              </div>
            </div>
          </div>
          <div
            class="modal fade"
            id="deletemodal"
            tabindex="-1"
            aria-labelledby="deletemodalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered delete-modal">
              <div class="modal-content">
                <div class="modal-body">
                  <div className="text-center delete-img-blk">
                    <img src={deleteimg} alt="delete-img"></img>
                  </div>
                  <div className="ques-title text-center">
                    Are you sure ?
                    <p className="m-0">
                      Are you sure you really want to delete this record? This
                      process cannot be undone.
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                  <button
                    type="button"
                    class="gray-outline-btn"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="button" class="orange-btn">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserListing;
